module.exports = __webpack_public_path__ + "static/fern.f1487089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/fern.svg
// module id = 135
// module chunks = 35783957827783 162898551421021